<car-details *ngIf="!itWorksAsVirtualLocationCategory && !!categorySelected && (categorySelected.toLowerCase() === this.enumLocationCategories.Car.toLowerCase() || categorySelected.toLowerCase() === this.enumLocationCategoriesSpanish.Car.toLowerCase())"></car-details>
<engineer-details *ngIf="!itWorksAsVirtualLocationCategory && !!categorySelected && (categorySelected.toLowerCase() === this.enumLocationCategories.Engineer.toLowerCase() || categorySelected.toLowerCase() === this.enumLocationCategoriesSpanish.Engineer.toLowerCase())"></engineer-details>
<service-details *ngIf="!itWorksAsVirtualLocationCategory && !!categorySelected && (categorySelected.toLowerCase() === this.enumLocationCategories.Service.toLowerCase() || categorySelected.toLowerCase() === this.enumLocationCategoriesSpanish.Service.toLowerCase())"></service-details>
<generic-location-details *ngIf="!itWorksAsVirtualLocationCategory && !!categorySelected && (!enumLocationCategoriesValues.includes(categorySelected.toLowerCase()) && !enumLocationCategoriesValuesSpanish.includes(categorySelected.toLowerCase()))"></generic-location-details>
<generic-virtual-location-details *ngIf="itWorksAsVirtualLocationCategory && !!categorySelected"></generic-virtual-location-details>
<!-- <generic-virtual-location-details *ngIf="itWorksAsVirtualLocationCategory && !!categorySelected && !enumLocationCategoriesValues.includes(categorySelected.toLowerCase()) && !enumLocationCategoriesValuesSpanish.includes(categorySelected.toLowerCase())"></generic-virtual-location-details> -->

<!-- eskeleton loader -->
<div class="popup" *ngIf="isLoading">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">
  
      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">
  
            <!-- Botón regresar-->
            <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar"><mat-icon>arrow_back_ios</mat-icon></a>
  
            <!-- Encabezado -->
            <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
              <ng-container *ngIf="isLoading">
                <div  class="img-car">
                  <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'height': '92px', 'width': '98%', 'margin': '2px auto -5px 1px', 'background-color': '#bdbdb9' }">
                  </ngx-skeleton-loader>
                </div>
              </ng-container>
            </div>
  
            <!-- VIN-->
            <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
              <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
              <label class="titlePanel vin-title"> 
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
              </label>
              
              <label class="subtitlePanel"> 
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
              </label>
              
              <label *ngIf="!mobileQuery.matches" class="header-text-label">Descripción</label>
              <label class="subtitlePanel"> 
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
              </label>
            </div>
  
        </div>
        <!-- seccion de tabs -->
        <div class="tab-group">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">

                </label>
              </ng-template>
              <ng-template matTabContent >
                  <div class="tab-content-wrapper" style="overflow: hidden;">
                    
                    <!-- primera sección -->
                    <div [ngClass]="{'container': mobileQuery.matches}">
                      <div class="row text-header">
                        <div class="section-header-background">
                          <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '50%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                      </div>

                       <!-- skeleton de carga -->
                       <ng-container *ngIf="this.isLoading">
                        <div *ngFor="let skel of [1,2,3,4,5,6,7,8,9,10]">
                          <div class="row row-data" [ngClass]="{'background-shade': (skel % 2 == 0)}">
                            <div class="col-4 d-flex align-items-center">
                              <label style="width: 100%; height: 100%;">
                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                              </label>
                            </div>
                            <div class="col-7 d-flex align-items-center">
                              <label style="width: 100%; height: 100%;">
                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px' }"></ngx-skeleton-loader>
                              </label>
                            </div>
                          </div>
                        </div>
                       </ng-container>

                    </div>

                </div>
  
              </ng-template>
            </mat-tab>
            
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>